/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Action_NameInputs */

const en_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`segment event group`)
};

const fr_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`segmenter le groupe d'evenements`)
};

const de_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment-Ereignisgruppe`)
};

const it_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gruppo di eventi del segmento`)
};

const ru_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`сегмент группы событий`)
};

const es_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grupo de eventos de segmento`)
};

const zh_cn2_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细分事件组`)
};

const ja_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントイベントグループ`)
};

const hi_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड घटना समूह`)
};

const pt_pt2_segment_event_group_action_name = /** @type {(inputs: Segment_Event_Group_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grupo de eventos de segmento`)
};

/**
* | output |
* | --- |
* | "segment event group" |
*
* @param {Segment_Event_Group_Action_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_action_name = /** @type {((inputs?: Segment_Event_Group_Action_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Action_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_action_name(inputs)
	if (locale === "de") return de_segment_event_group_action_name(inputs)
	if (locale === "it") return it_segment_event_group_action_name(inputs)
	if (locale === "ru") return ru_segment_event_group_action_name(inputs)
	if (locale === "es") return es_segment_event_group_action_name(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_action_name(inputs)
	if (locale === "ja") return ja_segment_event_group_action_name(inputs)
	if (locale === "hi") return hi_segment_event_group_action_name(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_action_name(inputs)
	return en_segment_event_group_action_name(inputs)
});